import _debounce from 'lodash/debounce'
import { Observable, observe, Scope } from 'cube'
import { GradeReacaoPorFabricanteData } from './service/query-bulas-site'

export const DEBOUNCE_ASYNC_ACTION = _debounce(Scope.ASYNC_ACTION, 1)
export const DEBOUNCE_ASYNC_ACTION_STRING = _debounce(Scope.ASYNC_ACTION_STRING, 1)

@Observable
export class AnaliseBulasScope extends Scope {
    @observe() loading = false
    readonly filtro = new FiltroScope()
    readonly table = new CompareTableScope()
}

export default AnaliseBulasScope

@Observable
export class FiltroScope extends Scope {
    readonly principiosAtivos = new DominioSelectScope()
    readonly fabricantes = new DominioSelectScope()
    readonly medicamentos = new DominioSelectScope()
    readonly reacoes = new DominioSelectScope()

    onConsultar = DEBOUNCE_ASYNC_ACTION
    onLimpar = Scope.ASYNC_ACTION
}

export type DominioOption = {
    label: string
    value: string
}

@Observable
export class DominioSelectScope extends Scope {
    @observe() value: string[] = []
    @observe() options: DominioOption[] = []
    @observe() loading = false

    onSearchChange = DEBOUNCE_ASYNC_ACTION_STRING
    onChangeOptions = Scope.ASYNC_ACTION_ONE<DominioOption[]>()
}

@Observable
export class CompareTableScope extends Scope {
    @observe() qtdeFabricatesAnalisados = 0
    @observe() qtdeCoberturasCompletas = 0
    @observe() qtdeCoberturaParciais = 0
    @observe() qtdeNaoDocumentadas = 0
    @observe() reacaoPorFabricanteData: GradeReacaoPorFabricanteData | null = null
}